const SixSeven = ({ gifSource }) => {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div className="w-[90%] h-[90%]">
                <img
                    src={gifSource}
                    className="w-full h-full object-contain"
                    style={{ maxWidth: '100%', maxHeight: '100%' }}
                />
            </div>
        </div>

    );
};

export default SixSeven;